import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngxs/store';
import { JwtState } from '@stores/jwt/jwt.state';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoggedGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly store: Store) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(JwtState).pipe(
      first(),
      map((jwtState) => !!jwtState),
      map((logged) => {
        if (state.url.startsWith(`/${FeaturesRoutingEnum.Dashboard}`)) {
          return true;
        }

        const queryString = route?.queryParamMap.keys
          .reduce((qs, key) => `${qs}${key}=${route.queryParamMap.get(key)}&`, '?')
          .slice(0, -1);

        const homeUrl = this.router.parseUrl(`/${FeaturesRoutingEnum.Dashboard}${queryString ?? ''}`);
        return !logged || homeUrl;
      })
    );
  }
}
